// Single source of truth for the premium admin's uniform proportional scale.
// The whole admin (dashboard, tournament detail + tabs, TV Control, and every
// other /admin route) renders inside ONE shared shell (AdminShell.jsx) that
// scales by this factor. Lower = smaller.
export const ADMIN_SCALE = 0.62

// Shared zoom driver used by AdminShell. Locks the design at a 1600-calibrated
// canvas widened to 1600/ADMIN_SCALE so it fills the viewport edge-to-edge at
// the calibrated zoom, left-anchored, one screen tall (sidebar sticky uses
// --admin-vh). Attach the returned ref to the shell element.
import { useLayoutEffect, useRef } from 'react'
import { PBCC_PREMIUM } from '../config/siteMode.js'

export function useAdminZoom() {
  const ref = useRef(null)
  useLayoutEffect(() => {
    if (!PBCC_PREMIUM) return
    const el = ref.current
    if (!el) return
    const apply = () => {
      const factor = (window.innerWidth / 1600) * ADMIN_SCALE
      const vh = window.innerHeight / factor
      el.style.zoom = String(factor)
      el.style.width = 1600 / ADMIN_SCALE + 'px'
      el.style.minHeight = vh + 'px'
      el.style.marginLeft = '0px'
      el.style.marginRight = '0px'
      el.style.setProperty('--admin-vh', vh + 'px')
    }
    apply()
    window.addEventListener('resize', apply)
    return () => window.removeEventListener('resize', apply)
  }, [])
  return ref
}
